export var PaymentSupportPanelSubject;
(function (PaymentSupportPanelSubject) {
    PaymentSupportPanelSubject["Panel"] = "payment-support-panel";
    PaymentSupportPanelSubject["InvoiceButton"] = "payment-support-panel-invoice-button";
    PaymentSupportPanelSubject["InvoiceModal"] = "payment-support-panel-invoice-modal";
    PaymentSupportPanelSubject["InvoiceSelect"] = "payment-support-panel-invoice-select";
    PaymentSupportPanelSubject["InvoicePeriodRange"] = "payment-support-panel-invoice-period-range";
    PaymentSupportPanelSubject["InvoiceNotification"] = "payment-support-panel-invoice-notification";
    PaymentSupportPanelSubject["UpdateDetailsButton"] = "payment-support-panel-update-details-button";
    PaymentSupportPanelSubject["UpdateDetailsModal"] = "payment-support-panel-update-details-modal";
    PaymentSupportPanelSubject["UpdateDetailsNotification"] = "payment-support-panel-update-details-notification";
})(PaymentSupportPanelSubject || (PaymentSupportPanelSubject = {}));
//# sourceMappingURL=payment-support-panel.enum.js.map